import { useCallback, useMemo, useState } from 'react';
import { RouterProvider } from 'quartz-routing';
import { GraniteRouter } from './GraniteRouter';
import { isGraniteEnabledForCurrentApp, getUngatedRemoteRoutes } from './granite-config';
import { getHostHistory } from 'quartz-routing/initialize';
import { GlobalErrorBoundary } from '../components/GlobalErrorBoundary';
import { ErrorPage } from '../components/ErrorPage';
import { getCurrentPackageName } from 'quartz/framework/environment/service';
export { isGraniteEnabledForCurrentApp };
import { getQuartzConfig } from 'quartz-config/evaluable';
import { getBasenameFromRouting } from '../util/getBasenameFromRouting';
import { getGraniteRuntime } from './GraniteRuntime';
import { createGraniteLocalApp } from './GraniteLocalApp';
import { jsx as _jsx } from "react/jsx-runtime";
export function createGraniteRuntimeHostAppRoot(localAppProps) {
  const runtime = getGraniteRuntime();
  const packageName = getCurrentPackageName();
  const quartzConfig = getQuartzConfig();
  const historyBasename = /* quartzConfig.type === 'application' */true ? quartzConfig.historyBasename || getBasenameFromRouting(quartzConfig.UNSAFE_EXPERIMENTAL_routing) : null;
  if (!historyBasename) {
    throw new Error('historyBasename is required for granite local app');
  }
  const localApp = createGraniteLocalApp(packageName, historyBasename, localAppProps, runtime);
  runtime.registerLocalApp(localApp);
  const GraniteRuntimeHostAppRoot = ({
    gates
  }) => {
    useState(() => {});
    const {
      remoteModules,
      localRouteOverrides
    } = useMemo(() => getUngatedRemoteRoutes(gates), [gates]);
    const getRoutes = useCallback(() => ({
      remoteModules,
      localRouteOverrides
    }), [remoteModules, localRouteOverrides]);
    return /*#__PURE__*/_jsx(GlobalErrorBoundary, {
      ErrorComponent: ErrorPage,
      children: /*#__PURE__*/_jsx(RouterProvider, {
        history: getHostHistory(),
        children: /*#__PURE__*/_jsx(GraniteRouter, {
          getRoutes: getRoutes,
          gates: gates
        })
      })
    });
  };
  return GraniteRuntimeHostAppRoot;
}